export default __webpack_public_path__ + "static/media/relay_design.549695a1.png";